import { render, staticRenderFns } from "./videoList2.vue?vue&type=template&id=2f1bcbb0&scoped=true&"
import script from "./videoList2.vue?vue&type=script&lang=js&"
export * from "./videoList2.vue?vue&type=script&lang=js&"
import style0 from "./videoList2.vue?vue&type=style&index=0&id=2f1bcbb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1bcbb0",
  null
  
)

export default component.exports